export default function GlobalBackgroundFX() {
  return (
    <div className="rsi-global-bg" aria-hidden="true">
      <div className="rsi-global-bg__nebula" />
      <div className="rsi-global-bg__grid" />
      <div className="rsi-global-bg__stars" />

      <div className="rsi-global-bg__world">
        <div className="rsi-global-bg__world-core" />
        <div className="rsi-global-bg__world-map" />
        <div className="rsi-global-bg__ring rsi-global-bg__ring--one" />
        <div className="rsi-global-bg__ring rsi-global-bg__ring--two" />
        <div className="rsi-global-bg__ring rsi-global-bg__ring--three" />
      </div>

      <div className="rsi-global-bg__planet rsi-global-bg__planet--small" />
      <div className="rsi-global-bg__planet rsi-global-bg__planet--accent" />
    </div>
  );
}
